import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import manageShowsTabRouter from "./manageShowsTabRouter";

function ManageShowsTab(props) {

  return (
    <TabTemplate 
      router={manageShowsTabRouter}
      passData={props.passData}
    />
  )

}

export default ManageShowsTab;